import { TFunction } from "./tlumacz";
import dayjs from "dayjs";
import logError from "./logError";

/**
 * Convert API errors to form fields.
 *
 * @param t
 * @param values
 * @param errors
 */
/**
 * Przeklada bledy walidacji z API na postac, ktorej oczekuje `setFields`.
 *
 * KSZTALT ZMIENIL SIE W ANTD 5 i to NIE JEST kosmetyka:
 *
 *   antd 3:  { nazwa_pola: { value, errors: [Error, ...] } }   <- obiekt, bledy jako Error
 *   antd 5:  [ { name: "nazwa_pola", value, errors: ["tekst"] } ]  <- TABLICA, bledy jako NAPISY
 *
 * Dwie roznice naraz: obiekt staje sie tablica z kluczem `name`, a obiekty
 * `Error` zwyklymi napisami. Przy starym ksztalcie `setFields` po prostu nic
 * nie robi - i komunikaty walidacyjne z serwera NIE POKAZUJA SIE przy polach.
 * Kompiluje sie bez zarzutu, bo `setFields` przyjmuje `any`.
 *
 * Uzywane w czterech formularzach: addressEdit, employee/create,
 * employee/edit, employee-document-type/create.
 */
export const convertApiErrorToForm = (t: TFunction, values: any, errors: any) => {
    const fields: any[] = [];

    for (const klucz of Object.keys(values)) {
        const fromApi: any = errors[klucz];
        if (typeof fromApi === 'undefined') continue;

        let value = values[klucz];
        if (klucz.indexOf('date') !== -1 || klucz.indexOf('expire') !== -1) {
            value = dayjs(values[klucz]);
        }

        const pole: any = { name: klucz, value };
        if (fromApi.hasOwnProperty('errors')) {
            // NAPISY, nie obiekty Error - antd 5 wyswietla je wprost
            pole.errors = fromApi.errors.map((komunikat: any) => t(komunikat));
        }
        fields.push(pole);
    }

    return fields;
};

/**
 * Check object is empty.
 *
 * @param obj
 */
export const isEmpty = (obj: object) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
};

/**
 * Converts Date format into YY/MM/DD hh/mm/ss from YY/MM/DD/T/hh/mm/ss
 * @param item
 */
export const displayDate = (item: Date) => {
    let date = new Date(item);
    let dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 ))
        .toISOString()
        .split("T")[0];
    let timeString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 ))
        .toISOString()
        .split("T")[1]
        .substring(0,8);
    return dateString+" "+timeString
};

/**
 * Converts Date format into YY/MM/DD from YY/MM/DD/T/hh/mm/ss
 * @param item
 */
export const displayDateHalf = (item: Date) => {
    let date = new Date(item);
    return new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
        .toISOString()
        .split("T")[0]
};

/**
 * Converts milliseconds to hh/mm/ss
 * @param duration
 */
export function msToTime(duration: number) {
    var seconds: string | number = Math.floor((duration / 1000) % 60),
        minutes: string | number = Math.floor((duration / (1000 * 60)) % 60),
        hours: string | number = Math.floor((duration / (1000 * 60 * 60)));
    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;
    return hours + ":" + minutes + ":" + seconds;
}

/**
 * Converts HH:mm:ss into milliseconds
 * @param duration
 */
export function hhmmssToMs(duration: string) {
    if (!duration) return 0;
    let time = duration.split(":", 3);
    let h = parseInt(time[0]) * 3600000;
    let m = parseInt(time[1]) * 60000;
    let s = parseInt(time[2]) * 1000;
    return h + m + s;
}

/**
 * Converts seconds to HH:mm:ss format
 * @param duration
 */
export function secondsToTimeFormat(duration: number) {
    let hours: any = Math.floor(duration / 60 / 60);
    let minutes: any = Math.floor(duration / 60) - (hours * 60);
    let seconds: any = duration % 60;
    if (seconds < 10) seconds = `0${seconds}`;
    if (minutes < 10) minutes = `0${minutes}`;
    if (hours < 10) hours = `0${hours}`;


    return hours + ":" + minutes + ":" + seconds;
}

/**
 * Converts miliseconds to HH:mm:ss format
 * @param duration
 */
export function msToTimeFormat(duration: number) {
    let x = duration / 1000;
    let hours = Math.floor(x / 60 / 60);
    let minutes = Math.floor(x / 60) - (hours * 60);
    let seconds = x % 60;
    return hours + ":" + minutes + ":" + seconds;
}

/**
 * Sets query
 * @param data: e.g. ({key:val}, {key2:val2}) => (...)
 */
export function setQuery(...data:any){
    let query = "?";
    data.forEach( (item:any) => {
        query = query + `${Object.keys(item)}=${Object.values(item)}&`;
    });
    return query.slice(0,query.length-1)
}

/**
 * Get super admin workspace assigned
 */
export function getSessionSuperAdminWorkspace(){
    let x:any = sessionStorage.getItem("superAdminWorkspace");
    if (x !== null && typeof x === "string") x = JSON.parse(x);
    return x
}

/**
 * Get is superAdmin true / false
 */
export function isSuperAdmin(){
    try {
        const x = sessionStorage.getItem("superAdmin");
        return !(!x || x === "false" || x === "null" || x === "undefined");
    } catch (e) { logError("utils/utils/isSuperAdmin", e); }
}

export function validateSessionStorage(val: string){
    const x = sessionStorage.getItem(val);
    return !(!x || x === "false" || x === "null" || x === "undefined");
}

export function validateLocalStorage(val: string){
    const x = localStorage.getItem(val);
    return !(!x || x === "false" || x === "null" || x === "undefined");
}

/**
 * Summ values
 */
export function sumIfExist(a: any=0, b: any=0, c: any=0, d: any=0, ){
    return parseFloat(a)+parseFloat(b)+parseFloat(c)+parseFloat(d)
}

/**
 * Check text in object
 */
export function getIndex(value:any, arr:any, prop:any){
    for(let i = 0; i < arr.length; i++) {
        if(arr[i][prop] === value) {
            return i;
        }
    }
    return -1;
}

/**
 *Check the number of days between dates
 * @param date1
 * @param date2
 */
export function dateDiffInDays(date1:any, date2:any) {
    return Math.round((date2-date1)/(1000*60*60*24));
}
